import { updateMinorUnitApi, getMinorUnitApi } from "@/api/action-defines/site-management";
import { showToast } from '@/@core/utils/utils';
import { mapGetters, mapState } from 'vuex';
import { EInvoiceConfigurationCode } from "@/@core/data/enum/menuCode";

export default {
  data() {
    return {
      minorUnitQuantity: '',
      minorUnitUnitPriceQuantity: '',
    }
  },
  async created() {
    await this.getEInvoiceConfiguration();
  },
  computed: {
     ...mapGetters({
          $ls_CurrentSiteID: 'auth/currentSiteID',
          $lsAllowOperation: 'app/allowOperation',
        }),
   
  },
  methods: {
    /**
     * Dịch theo khóa; khóa chưa được seed ở môi trường này thì hiện câu tiếng Việt cũ thay vì lộ tên khóa.
     * (Trước đây màn này dùng thẳng câu tiếng Việt làm khóa — cột KeywordCode là varchar nên không seed được,
     * chuyển sang tiếng Anh vẫn ra tiếng Việt.)
     */
    tOr(key, fallback) {
      return this.$te(key) ? this.$t(key) : fallback;
    },

    preventInvalidChar(event) {
      const char = String.fromCharCode(event.keyCode || event.which);
      const isValid = /^[0-9]$/.test(char);
      if (!isValid) {
        event.preventDefault();
      }
    },
   isCanEditEInvoiceConfiguration() {    
        return this.$lsAllowOperation(EInvoiceConfigurationCode.EDIT);
    },
    async getEInvoiceConfiguration() {
      try {
        const response = await getMinorUnitApi();
        if (response && response.Data) {
          this.minorUnitQuantity = response.Data.MinorUnit;
          this.minorUnitUnitPriceQuantity = response.Data.PriceMinorUnit;
        }
      } catch (error) {
        showToast('error', this.tOr('e_invoice_configuration_decimal_load_failed', 'Lấy thông tin số thập phân thất bại'));
      }
    },

    async updateEInvoiceConfiguration() {
      try {
        const BodyData = {
          MinorUnit: this.minorUnitQuantity,
          PriceMinorUnit: this.minorUnitUnitPriceQuantity
        };
        const response = await updateMinorUnitApi({ BodyData });

        if (response && response.StatusCode == 200) {
          showToast('success', this.tOr('e_invoice_configuration_decimal_update_success', 'Cập nhật thành công'));
        } else {
          showToast('error', this.tOr('e_invoice_configuration_decimal_update_failed', 'Cập nhật thất bại'));
        }
      } catch (error) {
        showToast('error', this.tOr('e_invoice_configuration_decimal_update_failed', 'Cập nhật số thập phân lỗi'));
      }
    }

  },
}
